import { gql } from 'graphql-request'

export default gql`
  query getMedicalEquipmentReviewGroup($provider: String) {
    applications {
      medicalEquipment {
        reviewGroup(provider: $provider) {
          success
          items {
            hRegistroEnderecoEquipamento
            endereco
            enderecoNumero
            equipamento
            marca
            modelo
            numeroSerie
            ano
            status
            hSituacao
            tabEndereco
            enderecoLivre
            tabEquipamento
            equipamentoLivre
          }
        }
      }
    }
  }
`
